import {
  formatPaperDate,
  formatPaperElapsed,
} from "../../PracticePapers/utils/formatPaperTime"
import { scoreBand } from "../../PracticePapers/utils/scoreThreshold"

export const formatAssessorDate = formatPaperDate
export const formatAssessorTime = formatPaperElapsed

export const pctOf = (score: number | null | undefined, max: number | null | undefined) => {
  if (!max || max <= 0) return 0
  return Math.round(((score ?? 0) / max) * 100)
}

export const scoreToneClass = (pct: number) => `is-${scoreBand(pct)}`
